import React, { useRef } from 'react';

import Field from 'components/FieldWithoutGrid';
import MaterialInput from 'components/MaterialInput';
import { Mobile, Desktop } from 'components/Responsive';
import CountryCodeSelect, { CountryCode } from 'components/Selects/CountryCodeSelect';
import useIsMobile from 'hooks/useIsMobile';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { CountryCodeContainer, PhoneInput as Input } from './styles';

interface Props {
  phoneField: string;
  countryCodeField: string;
  countryCodes: CountryCode[];
  selectedCountry?: string;
  mask?: string;
}

const PhoneInput = ({ phoneField, countryCodeField, countryCodes, mask, selectedCountry }: Props) => {
  
  const { t } = useStoreTranslation();
  const isMobile = useIsMobile();
  const countryRef = useRef(null);
  const placeholder = t(`registrationOnboarding.administrator.telephonePlaceholder${isMobile ? 'Mobile' : ''}`);

  if (countryCodes.length === 0) return null;

  const valueDefault = countryCodes.find((country) => country.code === selectedCountry);

  return (
    <>
      <Desktop>
        <Field name={phoneField}>
          <Input mask={mask} placeholder={placeholder} autoCapitalize="off" autoCorrect="off" type="tel">
            <CountryCodeContainer>
              <Field name={countryCodeField}>
                <CountryCodeSelect
                  defaultValue={valueDefault}
                  selectRef={countryRef}
                  onSetValue={(value: CountryCode) => value.code}
                  countryCodes={countryCodes}
                />
              </Field>
            </CountryCodeContainer>
          </Input>
        </Field>
      </Desktop>

      <Mobile>
        <MaterialInput
          name={phoneField}
          placeholder={placeholder}
          mask={mask}
          startAdornment={
            <Field name={countryCodeField}>
              <CountryCodeSelect
              defaultValue={valueDefault}
                selectRef={countryRef}
                onSetValue={(value: CountryCode) => value.code}
                countryCodes={countryCodes}
              />
            </Field>
          }
        />
      </Mobile>
    </>
  );
};

export default PhoneInput;
